export default "__VITE_ASSET__3UwtI1Vx__"